import styled from "styled-components";

export const MainContainer = styled.div<{ $isFullPage: boolean }>`
	height: 100%;
	width: 100%;
	display: grid;
	place-content: center;
	min-height: ${(props) => (props.$isFullPage ? "100vh" : "auto")};
`;